export default __webpack_public_path__ + "static/media/reply.d17a3171.svg";